import { priceComparator } from '@components/Sorting/Provider';
import { createBestItineraryData } from './createBestItineraryData';

const CheapestPrimeDayDealItineraryBuilder = () => {
  let primeDayPosition;
  let primeDay = {
    price: {
      amount: Infinity,
    },
  };

  return {
    add(itinerary, position) {
      if (
        itinerary.campaignConfig?.primeDayConfig?.isPrimeDayFare &&
        priceComparator(itinerary, primeDay) < 0
      ) {
        primeDay = itinerary;
        primeDayPosition = position;
      }
    },
    build() {
      return createBestItineraryData('primeDay', primeDay, primeDayPosition);
    },
  };
};

export default CheapestPrimeDayDealItineraryBuilder;
